import formatCurrency from 'core-lib/utils/currency';
import React from 'react';
import { ProductDescription } from 'src/modules/parkplusStoreV2/types/product';
import AnimatedImage from 'core-lib/components/AnimatedImage';
import { Typography } from 'ui-v2/components/Typography';
import s from './CoreDetails.module.scss';
import { Badge } from 'ui-v2/components/Badge';

type CoreDetailsProps = {
  data: ProductDescription;
};

export const CoreDetails: React.FunctionComponent<CoreDetailsProps> = ({
  data,
}) => {
  const showListingPrice = data?.price > data?.discountedPrice;
  return (
    <div className={s.body}>
      <div className={s.title_container}>
        <Typography
          label={data?.subtitle1}
          variant="label_3_medium"
          color="secondary"
        />
        <Typography label={data?.title} variant="label_2_medium" />
      </div>
      <div className={s.priceContainer}>
        <div className={s.price}>
          {data?.discountedPrice > 0 && (
            <Typography
              label={formatCurrency(data?.discountedPrice)}
              variant={'label_1_bold'}
            />
          )}
          {showListingPrice && (
            <Typography
              label={formatCurrency(data.price)}
              variant={'label_2_regular'}
              color="tertiary"
              className={s.lineThrough}
            />
          )}
        </div>
        {data?.loyaltyPoints > 0 && data?.loyaltyPrice > 0 && (
          <div className={s.mlSection}>
            <div className={s.mlPrice}>
              <Typography
                label={`or ₹${data?.loyaltyPrice} using `}
                color="offer"
                variant="label_2_semi_bold"
              />
              <AnimatedImage
                src="https://parkplus-bkt-img.parkplus.io/production/team/public/FS_20240104160730062768.png"
                className={s.drop}
                alt="mlDrop"
              />
              <Typography
                label={`${data?.loyaltyPoints} ml`}
                color="offer"
                variant="label_2_semi_bold"
                style={{
                  marginTop: '2px',
                }}
              />
            </div>
            {data?.priceNudge ? (
              <div className={s.priceNudgeBadge}>
                <div className={s.animatedText}></div>
                <Typography
                  label={data?.priceNudge}
                  color="on_dark_bg"
                  variant="label_4_bold"
                />
              </div>
            ) : (
              <>
                <Badge
                  type="secondary"
                  state="positive"
                  label={`SAVE ${formatCurrency(
                    data?.discountedPrice - data?.loyaltyPrice
                  )}`}
                />
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
